module.exports = __webpack_public_path__ + "img/smartFarming-LOGO.7bc8597e.png";